// Use the order's session snapshot so later product edits cannot change its subject.
export function buildReceiptEmailSubject(order, productName) {
  const session = order.items?.[0]?.product?.session;
  const sessionDate =
    typeof session?.date === 'string' ? session.date.trim() : '';
  let prefix = '';

  if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(sessionDate)) {
    const date = new Date(`${sessionDate}T00:00:00Z`);
    if (
      Number(sessionDate.slice(0, 4)) > 0 &&
      !Number.isNaN(date.getTime()) &&
      date.toISOString().slice(0, 10) === sessionDate
    ) {
      prefix = sessionDate;
    }
  }

  if (prefix) {
    const startTime =
      typeof session?.start_time === 'string' ? session.start_time.trim() : '';
    if (/^(?:[01][0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$/.test(startTime)) {
      prefix += ` ${startTime.slice(0, 5)}`;
    }
    prefix += ' ';
  }

  return `收據開立通知 - ${order.buyer_name || ''} ${prefix}${productName}`;
}
